export { default } from './camelCase'
